import { ApiResultState, CallState, LoadingState } from "@app/root-store/api-result.state";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { EntityWithAncestors } from "../services/entity-db.service";

export interface EntityState {
    entities: { result: { [id: number]: EntityWithAncestors }; callState: CallState<ClareDbCollection<EntityWithAncestors>> };
}

export interface EntitiesState extends ApiResultState<ClareDbCollection<EntityWithAncestors>> {}

export const initialEntityState: EntityState = {
    entities: { result: null, callState: LoadingState.init },
};
